const fontPrimary = [
    'Lato',
    '-apple-system',
    'BlinkMacSystemFont',
    'Segoe UI',
    'Roboto',
    'Oxygen',
    'Ubuntu',
    'Cantarell',
    'Fira Sans',
    'Droid Sans',
    'Helvetica',
    'Helvetica Neue',
    'Arial',
    'sans-serif',
    'Apple Color Emoji',
    'Segoe UI Emoji',
    'Segoe UI Symbol',
].join(', ')

const customProperties = {
    fontPrimary,
    fontSecondary: fontPrimary,
    swatchBody: '#f8f8f8',
    swatchFont: '#333333',
    swatchPrimary: '#2566b8',
    swatchSecondary: '#ff563b',
    swatchSuccess: '#86C06A',
    swatchWarning: '#f2d84e',
    swatchError: '#FF6161',
    gutter: 16,
    widthMobile: 767,
    widthTablet: 991,
    widthDesktop: 1199,
    headerHeight: 80,
}

const customMedia = {
    '--mobile': `only screen and (max-width : ${
        customProperties.widthMobile
    }px)`,
    '--tablet': `only screen and (min-width : ${customProperties.widthMobile +
        1}px) and (max-width : ${customProperties.widthTablet}px)`,
    '--tabletUp': `only screen and (min-width : ${customProperties.widthMobile +
        1}px)`,
    '--tabletDown': `only screen and (max-width : ${
        customProperties.widthTablet
    }px)`,
    '--desktop': `only screen and (min-width : ${customProperties.widthTablet +
        1}px) and (max-width : ${customProperties.widthDesktop}px)`,
    '--desktopUp': `only screen and (min-width : ${customProperties.widthTablet +
        1}px)`,
    '--desktopDown': `only screen and (max-width : ${
        customProperties.widthDesktop
    }px)`,
    '--desktopBig': `only screen and (min-width : ${customProperties.widthDesktop +
        1}px)`,
}

module.exports = {
    customProperties,
    customMedia,
}



// WEBPACK FOOTER //
// ../config/variables.js